import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import { Layout as AntLayout } from 'antd';
import classnames from 'classnames';

function Layout({ children }) {
  return (
    <AntLayout>
      <Sidebar />
      <AntLayout.Content>
        <Header />
        <div className="overflow-x-scroll min-h-screen">{children}</div>
        <Footer />
      </AntLayout.Content>
    </AntLayout>
  );
}

export default Layout;

Layout.Page = ({ className, children }) => <div className={classnames('p-md lg:px-[60px]', className)}>{children}</div>;
